var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-position": "top",
              "label-width": "120px"
            }
          },
          [
            _vm._l(_vm.formJson, function(item) {
              return _c(
                "el-form-item",
                {
                  key: item.prop,
                  attrs: { label: item.label, prop: item.prop }
                },
                [
                  item.prop != "systemId"
                    ? _c("el-input", {
                        class: item.maxclass,
                        attrs: {
                          disabled: item.disabled,
                          size: "small",
                          placeholder: item.placeholder,
                          maxlength: item.maxlength,
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.ruleForm[item.prop],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              item.prop,
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm[item.prop]"
                        }
                      })
                    : _vm._e(),
                  item.prop == "systemId"
                    ? _c("el-input", {
                        attrs: {
                          disabled: item.disabled,
                          size: "small",
                          value: _vm._f("filterSystemID")(
                            _vm.ruleForm[item.prop],
                            _vm.date.selectData
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            _vm.date.subType == "edit"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "键值对状态：" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          placeholder: "请选择键值对状态"
                        },
                        model: {
                          value: _vm.ruleForm["dictStatus"],
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "dictStatus", $$v)
                          },
                          expression: "ruleForm['dictStatus']"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "有效", value: "VALID" }
                        }),
                        _c("el-option", {
                          attrs: { label: "失效", value: "INVALID" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c("el-button", { on: { click: _vm.cancelDailog } }, [_vm._v("取消")]),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title:
                _vm.date.subType == "edit"
                  ? "确认修改此键值对？"
                  : "确认添加此键值对"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: { slot: "reference", type: "primary" },
                slot: "reference"
              },
              [_vm._v("确认")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }